import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import VideoPlayer from '../../shared/VideoPlayer';
import { GUIDE_VIDEO_RESOURCES } from './resources';
import './GuideVideoModal.css';

interface GuideVideoModalProps {
  open: boolean;
  onClose: () => void;
}

const GuideVideoModal: React.FC<GuideVideoModalProps> = ({ open, onClose }) => (
  <Modal
    open={open}
    centered
    closable={false}
    footer={null}
    width={1043}
    destroyOnHidden
    maskClosable
    onCancel={onClose}
    className="guide-video-modal"
  >
    <div className="guide-video-modal__shell">
      <div className="guide-video-modal__header">
        <span className="guide-video-modal__title">操作演示</span>
        <Button
          type="text"
          className="guide-video-modal__close"
          onClick={onClose}
          aria-label="关闭使用说明弹窗"
          icon={<CloseOutlined />}
        />
      </div>
      <VideoPlayer
        sources={GUIDE_VIDEO_RESOURCES}
        autoPlay
      />
    </div>
  </Modal>
);

export default GuideVideoModal;
